

/// <reference path="StockNoteProductLine.ts" />

// Generated class TransferNoteLine_ManagedObject

class TransferNoteLine_ManagedObject extends StockNoteProductLine
{
}
